import { faSignIn } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Link from 'next/link'

interface IProps {
  email: string
}

function EmailUsedNotice({ email }: IProps) {
  return (
    <div className="bg-red-50 sm:rounded-lg">
      <div className="px-4 py-5 sm:p-6">
        <h3 className="text-lg leading-6 font-medium text-gray-900">
          Email already used
        </h3>
        <div className="mt-2 max-w-xl text-sm text-gray-500">
          <p>
            {`This email address is already associated with an
        Upstream account. Would you like to login instead?`}
          </p>
        </div>

        <div className="mt-5">
          <Link
            className="inline-flex items-center px-4 py-2 border border-gray-300 shadow-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:text-sm"
            href={`/auth/login?email=${encodeURIComponent(email)}`}
          >
            {`Log in `}
            <FontAwesomeIcon icon={faSignIn} className="ml-2" />
          </Link>
        </div>
      </div>
    </div>
  )
}

export default EmailUsedNotice
